import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import Modal from 'react-modal';
import { useLanguage } from "../../hooks/useLanguage";
import api from "../../services/api";

import styles from './index.module.scss';

Modal.setAppElement('#root');

export default function TermsAndConditions({ modalIsOpen, handleCloseModal }) {
  const [termsAndConditions, setTermsAndConditions] = useState([]);

  const { language } = useLanguage();

  const handleUploadTermsAndConditions = async () => {
    const { data } = await api.get('paginas', {
      params: {
        Nome: '',
        Tag: 'Termos',
        Condicoes: '',
        IdiomaId: language
      }
    });

    setTermsAndConditions(data.value);
  }

  useEffect(() => {
    if (!language) return;

    handleUploadTermsAndConditions();
  }, [language]);

  return modalIsOpen && (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={handleCloseModal}
      overlayClassName={styles.modalOverlay}
      className={styles.modal}
    >
      <h2 dangerouslySetInnerHTML={{ __html: termsAndConditions?.titulo }}></h2>
      <button className={styles.close} onClick={handleCloseModal}><MdClose /></button>
      <div className={styles.content} dangerouslySetInnerHTML={{ __html: termsAndConditions?.conteudo }}></div>
    </Modal>
  );
} 